module.exports = __webpack_public_path__ + "img/INT-tab.ebf181c5.jpg";